import { render, staticRenderFns } from "./DailyKpiTable.vue?vue&type=template&id=48317c63"
import script from "./DailyKpiTable.vue?vue&type=script&lang=js"
export * from "./DailyKpiTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports